import { render, staticRenderFns } from "./MyAppsPopoverItem.vue?vue&type=template&id=8e5839ea&"
import script from "./MyAppsPopoverItem.vue?vue&type=script&lang=js&"
export * from "./MyAppsPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports